import { render } from "./ValidationError.vue?vue&type=template&id=50738a96&scoped=true"
import script from "./ValidationError.js?vue&type=script&lang=js"
export * from "./ValidationError.js?vue&type=script&lang=js"

import "./style.css?vue&type=style&index=0&id=50738a96&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50738a96"]])

export default __exports__